import { Col } from 'react-bootstrap';
import { Card } from '@pmi/dsm-react';
import { AlertSuccessSolidIcon } from '@pmi/dsm-react/dist/components/icons';
import { AccountSelectCardItem } from './models';
import styles from './accountselect.module.scss';

interface AccountSelectCardProps {
  selectedId: string;
  cardDetails: AccountSelectCardItem;
  handleClick: (id: string) => void;
}

export default function AccountSelectCard({
  selectedId,
  cardDetails,
  handleClick,
}: AccountSelectCardProps) {
  return (
    <Col sm={6} md={4} lg={3} className="my-2 text-center" key={cardDetails.id}>
      <div
        className={`cursor-pointer  h-100 ${
          selectedId === cardDetails.id ? 'border border-dark border-2' : ''
        }`}
        aria-label={cardDetails.accountName}
        aria-checked={selectedId === cardDetails.id}
        tabIndex={0}
        role="radio"
        onClick={() => handleClick(cardDetails.id)}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            handleClick(cardDetails.id);
          }
        }}
      >
        <Card className={`${styles.accountCard} d-flex flex-column p-2 h-100`}>
          <div className="position-relative p-3 me-3">
            {selectedId === cardDetails.id && (
              <AlertSuccessSolidIcon
                className="position-absolute end-0"
                color="success"
                fontSize="xs"
              />
            )}
          </div>
          <img
            className="m-auto mb-2 object-fit-contain"
            width="100"
            height="100"
            src={
              (cardDetails.logoUrl?.length > 0 && cardDetails.logoUrl) ||
              'https://upload.wikimedia.org/wikipedia/commons/3/3f/Placeholder_view_vector.svg'
            }
            alt="placeholder"
          />
          <h6>{cardDetails.accountName}</h6>
        </Card>
      </div>
    </Col>
  );
}
